// extracted by mini-css-extract-plugin
export default {"tooltipRoot":"styles_tooltipRoot__BUMS9","cleanStyle":"styles_cleanStyle__oryRl","textTooltip":"styles_textTooltip__JT5rn"};